import React from 'react';
import './Legal.scss';

const TermsOfService = () => {
  return (
    <div className="legal-page">
      <div className="legal-page__container">
        <header className="legal-page__header">
          <h1 className="legal-page__title">Terms of Service</h1>
          <p className="legal-page__last-updated">Last updated: August 2025</p>
        </header>

        <div className="legal-page__content">
          <section className="legal-page__section">
            <h2>Use of Service</h2>
            <p>You agree to use GuessNexus only for lawful purposes and in a way that does not violate the rights of others.</p>
          </section>

          <section className="legal-page__section">
            <h2>User Accounts</h2>
            <p>You are responsible for your account and any activity under it. Choose an appropriate username and keep your login information secure.</p>
          </section>

          <section className="legal-page__section">
            <h2>User Content</h2>
            <p>
              Any content you submit (usernames, feedback, profile information) must not violate laws or infringe on others' rights. 
              You grant us permission to display this content as part of our service.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>Third-Party Content</h2>
            <p>
              Our games reference content from various sources (Slay the Spire, Age of Empires II, Subnautica, etc.). 
              We don't claim ownership of this content - all trademarks belong to their respective owners.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>Service Disclaimer</h2>
            <p>
              GuessNexus is provided "as is" without warranties. We cannot guarantee the service will be error-free 
              or always available, and you use it at your own risk.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>Limitation of Liability</h2>
            <p>We are not liable for any damages resulting from your use of GuessNexus.</p>
          </section>

          <section className="legal-page__section">
            <h2>Changes to Terms</h2>
            <p>
              We may update these terms at any time. Continued use of GuessNexus means you accept any changes.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>Governing Law</h2>
            <p>These terms are governed by United States law.</p>
          </section>

          <section className="legal-page__section">
            <h2>Contact</h2>
            <p>Questions about these terms? Email us at guessnexuscompany@gmail.com</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;